const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://rrf87k86o7.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://w78fyuwtl1.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'hotfix/CV4-3158-cascade-parent-status',
    HOSTNAME: 'https://company.dev.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://ff1aofwdkd.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;